// Re-export useAuth from the context module for convenience
export { useAuth } from "@/contexts/AuthContext";
